// removed by extract-text-webpack-plugin
module.exports = {"footer":"w0zeZJui-dWxOYi7J8Yuf","github-link":"_3JJ4Mc7WGc2xD19PlIb28q","githubLink":"_3JJ4Mc7WGc2xD19PlIb28q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/Footer/Footer.styl
// module id = 123
// module chunks = 0